<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 7a1 1 0 00-1 1v3.59l-1.71 1.7a1 1 0 000 1.42 1 1 0 001.42 0l2-2A1 1 0 0013 12V8a1 1 0 00-1-1z"/><path d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm1 17.93V19a1 1 0 00-2 0v.93A8 8 0 014.07 13H5a1 1 0 000-2h-.93A8 8 0 0111 4.07V5a1 1 0 002 0v-.93A8 8 0 0119.93 11H19a1 1 0 000 2h.93A8 8 0 0113 19.93z"/></svg>